import { render } from "./PostEdit.vue?vue&type=template&id=f35c9ddc&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=js"
export * from "./PostEdit.vue?vue&type=script&lang=js"

import "./PostEdit.vue?vue&type=style&index=0&id=f35c9ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35c9ddc"]])

export default __exports__